import React from 'react';

const LocationSelector = ({ onLocationSelect }) => {
    const locations = [
        { id: 'royaltech', name: 'RoyalTech', active: false, logo: '/logos/RT-logo.jpg' },
        { id: 'trueliberty', name: 'True Liberty', active: true, logo: '/logos/TL-logo.jpg' },
        { id: 'shuwaikh', name: 'Shuwaikh Store', active: true, logo: '/logos/Store-logo.jpg' },
        { id: 'bahman', name: 'Bahman Store', active: true, logo: '/logos/Store-logo.jpg' }
    ];

    const handleLocationClick = (location) => {
        if (location.active) {
            onLocationSelect(location.id);
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '20px'
        }}>
            <h2 style={{ marginBottom: '40px', color: '#333' }}>Select Location</h2>
            
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '30px',
                maxWidth: '600px',
                width: '100%'
            }}>
                {locations.map((location) => (
                    <div
                        key={location.id}
                        onClick={() => handleLocationClick(location)}
                        style={{
                            width: '100%',
                            height: '200px',
                            border: '3px solid #ddd',
                            borderRadius: '12px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: location.active ? 'pointer' : 'not-allowed',
                            backgroundColor: location.active ? '#fff' : '#f0f0f0',
                            backgroundImage: location.active 
                                ? 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'
                                : 'linear-gradient(135deg, #bbb 0%, #999 100%)',
                            color: '#fff',
                            transition: 'all 0.3s ease',
                            boxShadow: location.active 
                                ? '0px 8px 15px rgba(0, 0, 0, 0.2)' 
                                : '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            opacity: location.active ? 1 : 0.6,
                            transform: 'scale(1)',
                        }}
                        onMouseEnter={(e) => {
                            if (location.active) {
                                e.currentTarget.style.transform = 'scale(1.05)';
                                e.currentTarget.style.boxShadow = '0px 12px 20px rgba(0, 0, 0, 0.3)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (location.active) {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0px 8px 15px rgba(0, 0, 0, 0.2)';
                            }
                        }}
                    >
                        <img 
                            src={location.logo} 
                            alt={`${location.name} logo`}
                            style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'contain',
                                marginBottom: '10px',
                                filter: location.active ? 'none' : 'grayscale(100%) opacity(0.5)'
                            }}
                        />
                        <h3 style={{ 
                            margin: '0 0 15px 0', 
                            fontSize: '24px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            padding: '0 10px'
                        }}>
                            {location.name}
                        </h3>
                        
                        {!location.active && (
                            <span style={{
                                fontSize: '14px',
                                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                padding: '5px 15px',
                                borderRadius: '20px',
                                marginTop: '10px'
                            }}>
                                Coming Soon
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LocationSelector;